/* Al Aswad category metafield filters. No apps, external libraries or cart mutations. */
(() => {
  if (customElements.get('aa-collection')) return;
  customElements.define('aa-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { window.addEventListener('popstate', this.onBack); return; }
      this.ready = true;
      this.ar = this.dataset.ar === 'true';
      this.isSearch = this.dataset.mode === 'search';
      if (this.isSearch && !this.dataset.query.trim()) return;
      // Request the alternate image only when the customer hovers or focuses a card.
      const revealImage = e => {
        if (e.type === 'pointerover' && e.pointerType !== 'mouse') return;
        const card = e.target.closest('[data-hover-image]');
        if (!card || !this.contains(card) || card.dataset.hoverLoading) return;
        card.dataset.hoverLoading = 'true';
        const img = document.createElement('img');
        img.className = 'aa-collection__hover-image';
        img.alt = ''; img.setAttribute('aria-hidden', 'true'); img.decoding = 'async';
        img.addEventListener('load', () => card.classList.add('has-hover-image'), { once: true });
        img.addEventListener('error', () => { img.remove(); delete card.dataset.hoverLoading; }, { once: true });
        img.sizes = '(min-width: 1000px) 25vw, 50vw';
        img.srcset = [240,360,540,720].map(w => { const u = new URL(card.dataset.hoverImage, location.origin); u.searchParams.set('width', w); return `${u.href} ${w}w`; }).join(', ');
        img.src = card.dataset.hoverImage;
        card.append(img);
      };
      if (!this.isSearch) {
        this.addEventListener('pointerover', revealImage);
        this.addEventListener('focusin', revealImage);
      }
      this.pageSize = Number(this.dataset.pageSize) || 24;
      this.state = { colors: [], category: [], fabrics: [], available: [], min: '', max: '', sort: this.dataset.defaultSort || 'created-descending', page: 1 };
      this.readURL();
      this.querySelector('[data-sort]').value = this.state.sort;
      this.querySelector('[data-min]').value = this.state.min === '' ? (this.minimum ?? '') : this.state.min;
      this.querySelector('[data-max]').value = this.state.max === '' ? (this.maximum ?? '') : this.state.max;
      this.addEventListener('toggle', e => { if (e.target.matches('details') && e.target.open) this.ensure().catch(() => {}); }, true);
      this.addEventListener('click', e => {
        if (e.target.closest('.aa-collection__toggle')) {
          const open = this.classList.toggle('is-open');
          this.querySelector('.aa-collection__toggle').setAttribute('aria-expanded', String(open));
          if (open) this.ensure().catch(() => {});
        }
        if (e.target.closest('[data-retry]')) this.apply().catch(() => {});
        if (e.target.closest('[data-clear]')) {
          Object.assign(this.state, { colors: [], category: [], fabrics: [], available: [], min: '', max: '', page: 1 });
          this.querySelectorAll('input[type=checkbox]').forEach(el => { el.checked = false; });
          this.querySelector('[data-min]').value = ''; this.querySelector('[data-max]').value = '';
          this.apply().catch(() => {});
        }
        const page = e.target.closest('button[data-page]');
        if (page) { this.state.page = Number(page.dataset.page); this.apply().catch(() => {}); }
      });
      this.addEventListener('change', e => {
        const el = e.target;
        if (el.dataset.group) this.state[el.dataset.group] = Array.from(this.querySelectorAll(`input[data-group="${el.dataset.group}"]:checked`), n => n.value);
        else if (el.matches('[data-sort]')) this.state.sort = el.value;
        else if (el.matches('[data-min]')) this.state.min = el.value;
        else if (el.matches('[data-max],[data-range]')) { this.state.max = el.value; this.querySelector('[data-max]').value = el.value; }
        else return;
        this.state.page = 1; this.apply().catch(() => {});
      });
      this.onBack = () => { this.readURL(); this.syncControls(); this.apply(false).catch(() => {}); };
      window.addEventListener('popstate', this.onBack);
      this.apply(false).catch(() => {});
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onBack); }
    async yieldToBrowser() {
      if (globalThis.scheduler?.yield) await globalThis.scheduler.yield();
      else await new Promise(resolve => setTimeout(resolve, 0));
    }
    words(en, ar) { return this.ar ? ar : en; }
    readURL() {
      const q = new URL(location.href).searchParams;
      for (const key of ['colors', 'category', 'fabrics', 'available']) this.state[key] = q.getAll('aa_' + key);
      for (const key of ['min','max']) {
        const value = q.get('aa_' + key);
        this.state[key] = value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : '';
      }
      const allowed = Array.from(this.querySelector('[data-sort]').options, option => option.value);
      const fallback = allowed.includes(this.dataset.defaultSort) ? this.dataset.defaultSort : 'created-descending';
      const sort = q.get('aa_sort') || q.get('sort_by');
      this.state.sort = allowed.includes(sort) ? sort : fallback;
      this.state.page = Math.max(1, parseInt(q.get('aa_page'), 10) || 1);
    }
    syncControls() {
      this.querySelector('[data-sort]').value = this.state.sort;
      this.querySelector('[data-min]').value = this.state.min === '' ? (this.minimum ?? '') : this.state.min;
      this.querySelector('[data-max]').value = this.state.max === '' ? (this.maximum ?? '') : this.state.max;
      this.querySelectorAll('[data-group]').forEach(el => { el.checked = this.state[el.dataset.group].includes(el.value); });
    }
    async ensure() {
      const order = this.isSearch ? 'relevance' : (['best-selling','most-relevant'].includes(this.state.sort) ? this.state.sort : 'manual');
      this.indexes ||= {};
      if (this.indexes[order]) { this.products = this.indexes[order]; return; }
      if (this.loading) { await this.loading; return this.ensure(); }
      const status = this.querySelector('[data-status]');
      status.hidden = false; status.textContent = this.words('Loading filters…', 'جارٍ تحميل الفلاتر…');
      this.querySelector('[data-retry]').hidden = true;
      this.setAttribute('aria-busy', 'true');
      this.loading = (async () => {
        const all = [];
        let pages = 1;
        for (let page = 1; page <= pages; page++) {
          const url = new URL(this.dataset.url, location.origin);
          // Keep draft preview context without carrying old native/tag filter parameters.
          const current = new URL(location.href);
          for (const key of ['preview_theme_id','_fd','pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
          url.searchParams.set('section_id', this.isSearch ? 'alaswad-search-data' : 'alaswad-collection-data');
          if (this.isSearch) {
            url.searchParams.set('q', this.dataset.query);
            url.searchParams.set('type', 'product');
            for (const key of ['options[prefix]','options[unavailable_products]']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
          }
          url.searchParams.set('sort_by', order); url.searchParams.set('page', page);
          const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
          if (!response.ok) throw new Error('index');
          const html = await response.text();
          await this.yieldToBrowser();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const template = doc.querySelector('template[data-aa-index]');
          if (!template) throw new Error('index');
          const data = JSON.parse(template.content.textContent);
          if (!Array.isArray(data.products) || data.total > 1000 || data.pages > (this.isSearch ? 20 : 4)) throw new Error('size');
          pages = data.pages;
          all.push(...data.products);
          if (page === pages && new Set(all.map(p => p.id)).size !== data.total) throw new Error('incomplete');
        }
        this.indexes[order] = all;
        this.products = all;
        await this.yieldToBrowser();
        this.buildOptions();
        const maximum = Math.max(0, ...all.map(p => p.price)) / 100;
        this.minimum = all.length ? Math.min(...all.map(p => p.price)) / 100 : 0;
        this.maximum = maximum;
        const range = this.querySelector('[data-range]');
        range.min = this.minimum; range.max = maximum; range.value = this.state.max || maximum; range.disabled = maximum === this.minimum;
        this.syncControls();
        status.hidden = true;
      })().catch(error => {
        status.hidden = false;
        status.textContent = this.words('Filters could not load. You can still browse the products below. Try again.', 'تعذر تحميل الفلاتر. يمكنك تصفح المنتجات أدناه والمحاولة مجدداً.');
        this.querySelector('[data-retry]').hidden = false;
        throw error;
      }).finally(() => { this.loading = null; this.removeAttribute('aria-busy'); });
      return this.loading;
    }
    buildOptions() {
      const groups = { colors: new Map(), category: new Map(), fabrics: new Map(), available: new Map() };
      for (const p of this.products) {
        for (const c of p.colors) if (c.label) groups.colors.set(c.label, c.swatch);
        if (p.category) groups.category.set(p.category, '');
        for (const f of p.fabrics) if (f) groups.fabrics.set(f, '');
      }
      groups.available.set('true', ''); groups.available.set('false', '');
      for (const [group, values] of Object.entries(groups)) {
        const target = this.querySelector(`[data-options="${group}"]`);
        const options = document.createDocumentFragment();
        for (const [value, swatch] of [...values.entries()].sort((a,b) => a[0].localeCompare(b[0]))) {
          const label = document.createElement('label'), input = document.createElement('input');
          input.type = 'checkbox'; input.dataset.group = group; input.value = value; input.checked = this.state[group].includes(value); label.append(input);
          if (group === 'colors' && /^#[0-9a-f]{3,8}$/i.test(swatch)) {
            const dot = document.createElement('span'); dot.className = 'aa-collection__swatch'; dot.style.backgroundColor = swatch; dot.setAttribute('aria-hidden','true'); label.append(dot);
          }
          const name = group === 'available' ? (value === 'true' ? this.words('Available to order', 'متوفر للطلب') : this.words('Sold out', 'نفدت الكمية')) : value;
          label.append(document.createTextNode(name)); options.append(label);
        }
        if (!values.size) { const p = document.createElement('p'); p.textContent = this.words('No values available', 'لا توجد خيارات متاحة'); options.append(p); }
        target.replaceChildren(options);
      }
    }
    results() {
      const s = this.state;
      const min = s.min === '' ? 0 : Number(s.min) * 100, max = s.max === '' ? Infinity : Number(s.max) * 100;
      return this.products.filter(p =>
        (!s.colors.length || p.colors.some(c => s.colors.includes(c.label))) &&
        (!s.category.length || s.category.includes(p.category)) &&
        (!s.fabrics.length || p.fabrics.some(f => s.fabrics.includes(f))) &&
        (!s.available.length || s.available.includes(String(p.available))) && p.price >= min && p.price <= max
      ).sort((a,b) => {
        if (s.sort === 'price-ascending') return a.price-b.price;
        if (s.sort === 'price-descending') return b.price-a.price;
        if (s.sort === 'title-ascending') return a.title.localeCompare(b.title);
        if (s.sort === 'title-descending') return b.title.localeCompare(a.title);
        if (s.sort === 'created-ascending') return Number(a.created)-Number(b.created);
        if (s.sort === 'created-descending') return Number(b.created)-Number(a.created);
        return 0;
      });
    }
    async apply(write = true) {
      const revision = this.revision = (this.revision || 0) + 1;
      await this.ensure();
      await this.yieldToBrowser();
      if (revision !== this.revision) return;
      this.syncControls();
      const result = this.results();
      const pages = Math.max(1, Math.ceil(result.length / this.pageSize));
      this.state.page = Math.min(this.state.page, pages);
      this.querySelector('[data-range]').value = this.state.max || this.querySelector('[data-range]').max;
      const grid = this.querySelector('[data-grid]');
      const visible = result.slice((this.state.page-1)*this.pageSize, this.state.page*this.pageSize);
      const currentLinks = Array.from(grid.querySelectorAll(':scope > article > a.aa-collection__image'));
      const sameCards = visible.length > 0 && currentLinks.length === visible.length &&
        currentLinks.every((link, index) => link.href === new URL(visible[index].url, location.origin).href);
      if (!sameCards) {
      const cards = document.createDocumentFragment();
      for (const p of visible) {
        const article = document.createElement('article'), link = document.createElement('a');
        link.className = 'aa-collection__image'; link.href = p.url;
        if (!this.isSearch && p.hoverImage) link.dataset.hoverImage = p.hoverImage;
        if (p.image) {
          const img = document.createElement('img'); img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.decoding = 'async'; img.width = 540; img.height = 900;
          img.srcset = [240,360,540,720].map(w => { const u = new URL(p.image, location.origin); u.searchParams.set('width', w); return `${u.href} ${w}w`; }).join(', ');
          img.sizes = '(min-width: 1000px) 25vw, 50vw'; link.append(img);
        } else link.textContent = p.title;
        const heading = document.createElement('h3'), title = document.createElement('a'); title.href = p.url; title.textContent = p.title; heading.append(title);
        const price = document.createElement('p'); price.textContent = (p.varies ? this.words('From ', 'من ') : '') + p.money;
        article.append(link, heading, price);
        if (!p.available) { const sold = document.createElement('span'); sold.textContent = this.words('Sold out','نفدت الكمية'); article.append(sold); }
        cards.append(article);
      }
      if (!result.length) { const p = document.createElement('p'); p.textContent = this.words('No matching products. Try clearing a filter.', 'لا توجد منتجات مطابقة. حاولي مسح أحد الفلاتر.'); cards.append(p); }
      grid.replaceChildren(cards);
      }
      this.querySelector('[data-count]').textContent = `${result.length} ${this.words('products','منتج')}`;
      const nav = this.querySelector('[data-pages]'); nav.replaceChildren();
      for (const [label,page] of [[this.words('Previous','السابق'),this.state.page-1],[this.words('Next','التالي'),this.state.page+1]]) {
        if (page < 1 || page > pages) continue;
        const button = document.createElement('button'); button.type = 'button'; button.dataset.page = page; button.textContent = label; nav.append(button);
      }
      const number = document.createElement('span'); number.textContent = `${this.state.page} / ${pages}`; nav.append(number);
      if (write) {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()]) if (key.startsWith('aa_') || key.startsWith('filter.') || ['page','sort_by'].includes(key)) url.searchParams.delete(key);
        for (const key of ['colors','category','fabrics','available']) for (const value of this.state[key]) url.searchParams.append('aa_'+key,value);
        for (const key of ['min','max','sort','page']) if (this.state[key] !== '') url.searchParams.set('aa_'+key,this.state[key]);
        if (this.isSearch) { url.searchParams.set('q', this.dataset.query); url.searchParams.set('type','product'); }
        if (url.href !== location.href) history.pushState({}, '', url);
      }
    }
  });
})();
